/**
 * @module linkage/chartTypeSwitch/reconcileForChartType/applyLayerPatch
 * @description base/draft 层 patch 应用；undefined 表示删除 key
 */

export function applyLayerPatch(
  layer: Record<string, unknown>,
  patch: Record<string, unknown>,
): Record<string, unknown> {
  const next = { ...layer };
  for (const [key, value] of Object.entries(patch)) {
    if (value === undefined) {
      delete next[key];
    } else {
      next[key] = value;
    }
  }
  return next;
}
